module.exports = __webpack_public_path__ + "static/media/right.7e1bfdd3.svg";